import { render, staticRenderFns } from "./linkToAdder.vue.html?vue&type=template&id=c9a1f3c4&"
import script from "./linkToAdder.ts?vue&type=script&lang=ts&"
export * from "./linkToAdder.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports